import {AlertComponent } from './alert.component';
import { AlertsService } from './alerts.service';
import { Component } from '@angular/core';
import { AlertsConfig } from 'config/alerts.config';

@Component({
  selector: 'app-error',
  templateUrl: './alert.component.html'
})
export class ErrorComponent extends AlertComponent {
  className = 'alert-error';
  timeout: number;

  constructor(
    protected service: AlertsService,
    config: AlertsConfig,
  ) {
    super(service);
    this.timeout = config.failureTimeout;
  }

  get message() {
    return this.service.error;
  }

  show(): void {
    super.show();
    setTimeout(() => this.hide(), this.timeout);
  }
}
